module.exports = __webpack_public_path__ + "img/12.2214a9b5.png";